//store can be defined similar to the composition API setup, but it doesn't work as expected.
import { defineStore } from "pinia";
import { MUTATE, QUERY } from "../api/index.js";
import { logout } from "@/api/api";

export const useDataStore = defineStore("main", {
  state: () => ({}),

  getters: {},

  actions: {
    increment() {
      this.count++;
    },
    reset() {
      Object.assign(this, defaultState);
    },
    resetVariable(variableName) {
      // Get the initial value based on the variable name
      if (Array.isArray(this[variableName])) {
        this[variableName] = [];
      } else if (typeof this[variableName] === "object") {
        this[variableName] = {};
      } else if (typeof this[variableName] === "string") {
        this[variableName] = "";
      } else if (typeof this[variableName] === "number") {
        this[variableName] = 0;
      }

      // Set the variable to its initial value
    },
    async mutate({ endpoint, data }) {
      try {
        return MUTATE(endpoint, data);
      } catch (e) {
        console.log("Error in mutate", e);
      }
    },

    async query({ endpoint, payload, storeKey }) {
      try {
        const res = await QUERY(endpoint, payload);

        if (res) {
          if (storeKey) {
            this[storeKey] = res;
          }
          return res;
        }
      } catch (e) {
        console.log(e);
        return e;
      }
    },
  },
  persist: true,
});
